  <!-- EMPTY STATE -->
<div *ngIf="show.loadingState"
      @skeletonAnimation
      class="vertical-container-simple column-gap-1 main">
  <div class="space-between-horizontal-centered row-gap-1">
    <div class="start-row-container row-gap-0p25">
      <app-table-group-icon></app-table-group-icon>
      <span class="font-1 bold600 main-8">Fair value</span>
      <app-all-icons [iconNameAndStyling]="'arrow-down.svg; icon-size-1p5; main-8'"></app-all-icons>
      <span class="font-1 bold600">by</span>
      <app-tabs-with-counter [tabNamesRaw]="tabNames"></app-tabs-with-counter>
    </div>
    <div class="flex items-center justify-start bold400 font-3 gap-0.46875">
      <span>From</span>
      <span class="width-12p5 height-2p5 bg-black-3 br-0p5"></span>
      <span>till</span>
      <span class="width-12p5 height-2p5  bg-black-3 br-0p5"></span>
    </div>
  </div>
  <div class="space-between-horizontal-centered row-gap-1">
    <div class="width-59pcnt height-30 bg-black-3 br-0p5"></div>
    <div class="width-39pcnt height-30 bg-black-3 br-0p5"></div>
  </div>
  <div class="width-100pcnt height-3 bg-black-3 br-0p5"></div>
</div>

<!-- COMPONENT -->
<div *ngIf="!show.loadingState" @appearAnimation class="vertical-container-simple column-gap-1 main">
  <form [formGroup]="filterForm">
    <div class="space-between-horizontal-centered row-gap-1">
      <div class="start-row-container row-gap-0p25">
        <app-table-group-icon class="clickable" [opened]="show.chart" (click)="show.chart = !show.chart"></app-table-group-icon>
        <div class="start-row-container row-gap-1">
          <div class="centered-row-container row-gap-0p5 height-1p875">
            <div class="position-rel">
              <div data-qa="fair-value-investment-selector"
                class="centered-row-container row-gap-0p3125 clickable"
                (click)="toggleSelector()">
                <div class="centered-row-container">
                  <span class="font-1 bold600 main-8">{{dropdown.selectedValue === menuValues.fmv ? 'Fair value' : 'Investment'}}</span>
                  <app-all-icons [iconNameAndStyling]="'arrow-down.svg; icon-size-1p5; main-8'"></app-all-icons>
                </div>
              </div>
              <app-popup-modal *ngIf="dropdown.show" data-qa="show-menu-carry" (closeModal)="toggleSelector()">
                <div class="select-body width-8 padding-0p5 vertical-container-simple column-gap-0p5">
                  <div class="font-3 clickable" [ngClass]="{'main-8': dropdown.selectedValue === menuValues.fmv}" (click)="selectMenuItem(menuValues.fmv)">Fair value</div>
                  <div class="font-3 clickable" [ngClass]="{'main-8': dropdown.selectedValue === menuValues.investment}" (click)="selectMenuItem(menuValues.investment)">Investment</div>
                </div>
              </app-popup-modal>
            </div>
            <span class="font-1 bold600">by</span>
          </div>
          <app-tabs-with-counter [tabNamesRaw]="tabNames" (selectedTabEmitter)="changeTab($event)"></app-tabs-with-counter>
        </div>
      </div>
      <div class="flex items-center justify-start bold400 font-3 gap-0.46875">
          <span>From</span>
          <app-input
            data-qa="minValue-input"
            formControlName="minValue"
            [thousandSeparator]="','"
            [separator]="'separator.0'"
            [allowNegativeNumbers]="true"
            [suffixFirstIcon]="'close.svg'"
            (suffixFirstIconEmitter)="refreshFilterData()">
          </app-input>
          <span>till</span>
          <app-input
            data-qa="maxValue-input"
            formControlName="maxValue"
            [thousandSeparator]="','"
            [separator]="'separator.0'">
          </app-input>
      </div>
    </div>
  </form>
  <div *ngIf="show.chart">
    <div *ngIf="selectedTab === tab.FUND" class="vertical-container-simple column-gap-1">
      <div class="centered-row-container row-gap-1">
        <div class="bordered width-59pcnt padding-0p5 height-28">
          <app-base-bar-drilldown-chart
            *ngIf="chart.options[dropdown.selectedValue].barChart.byFund.additionalOptions"
            [chartId]="chart.options[dropdown.selectedValue].barChart.byFund.chartId"
            [additionalOptions]="chart.options[dropdown.selectedValue].barChart.byFund.additionalOptions">
          </app-base-bar-drilldown-chart>
        </div>
        <div class="bordered width-39pcnt padding-0p5 height-28">
          <app-base-pie-chart
            *ngIf="chart.options[dropdown.selectedValue].pieChart.byFund.additionalOptions"
            [chartId]="chart.options[dropdown.selectedValue].pieChart.byFund.chartId"
            [additionalOptions]="chart.options[dropdown.selectedValue].pieChart.byFund.additionalOptions">
          </app-base-pie-chart>
        </div>
      </div>
      <app-data-behind-fv-and-pp-charts *ngIf="chart.data.fmv.barChart.byFund"
        [selectedOrgName]="organization.name"
        [rawData]="chart.data.fmv.barChart.byFund.drilldownData"
        [categoryName]="'Fund'">
      </app-data-behind-fv-and-pp-charts>
    </div>
    <div class="vertical-container-simple column-gap-1" *ngIf="selectedTab === tab.COMPANY">
        <div class="centered-row-container row-gap-1">
          <div class="bordered width-59pcnt padding-0p5 height-28">
            <app-base-bar-chart
              *ngIf="chart.options[dropdown.selectedValue].barChart.byCompany.additionalOptions"
              [chartId]="chart.options[dropdown.selectedValue].barChart.byCompany.chartId"
              [additionalOptions]="chart.options[dropdown.selectedValue].barChart.byCompany.additionalOptions">
            </app-base-bar-chart>
          </div>
          <div class="bordered width-39pcnt padding-0p5 height-28">
            <app-base-pie-chart
              *ngIf="chart.options[dropdown.selectedValue].barChart.byCompany.additionalOptions"
              [chartId]="chart.options[dropdown.selectedValue].pieChart.byCompany.chartId"
              [additionalOptions]="chart.options[dropdown.selectedValue].pieChart.byCompany.additionalOptions">
            </app-base-pie-chart>
          </div>
        </div>
        <app-data-behind-fv-and-pp-charts
          [selectedOrgName]="organization.name"
          [isOnlyCompanies]="true"
          [rawData]="chart.data.fmv.barChart.byGroup.drilldownData"
          [categoryName]="'Company'">
        </app-data-behind-fv-and-pp-charts>
    </div>
    <div class="vertical-container-simple column-gap-1" *ngIf="selectedTab === tab.INDUSTRY">
        <div class="centered-row-container row-gap-1">
          <div class="bordered width-59pcnt padding-0p5 height-28">
            <app-base-bar-drilldown-chart
              [chartId]="chart.options[dropdown.selectedValue].barChart.byIndustry.chartId"
              [additionalOptions]="chart.options[dropdown.selectedValue].barChart.byIndustry.additionalOptions">
            </app-base-bar-drilldown-chart>
          </div>
          <div class="bordered width-39pcnt padding-0p5 height-28">
            <app-base-pie-chart
              [chartId]="chart.options[dropdown.selectedValue].pieChart.byIndustry.chartId"
              [additionalOptions]="chart.options[dropdown.selectedValue].pieChart.byIndustry.additionalOptions">
            </app-base-pie-chart>
          </div>
        </div>
        <app-data-behind-fv-and-pp-charts
          [selectedOrgName]="organization.name"
          [rawData]="chart.data.fmv.barChart.byIndustry.drilldownData"
          [categoryName]="'Industry'">
        </app-data-behind-fv-and-pp-charts>
    </div>
    <div class="vertical-container-simple column-gap-1" *ngIf="selectedTab === tab.COUNTRY">
        <div class="centered-row-container row-gap-1">
          <div class="bordered width-59pcnt padding-0p5 height-28">
            <app-base-bar-drilldown-chart
              [chartId]="chart.options[dropdown.selectedValue].barChart.byCountry.chartId"
              [additionalOptions]="chart.options[dropdown.selectedValue].barChart.byCountry.additionalOptions">
            </app-base-bar-drilldown-chart>
          </div>
          <div class="bordered width-39pcnt padding-0p5 height-28">
            <app-base-pie-chart
              [chartId]="chart.options[dropdown.selectedValue].pieChart.byCountry.chartId"
              [additionalOptions]="chart.options[dropdown.selectedValue].pieChart.byCountry.additionalOptions">
            </app-base-pie-chart>
          </div>
        </div>
        <app-data-behind-fv-and-pp-charts
          [selectedOrgName]="organization.name"
          [rawData]="chart.data.fmv.barChart.byCountry.drilldownData"
          [categoryName]="'Country'">
        </app-data-behind-fv-and-pp-charts>
    </div>
    <div class="vertical-container-simple column-gap-1" *ngIf="selectedTab === tab.GROUP">
        <div class="centered-row-container row-gap-1">
          <div class="bordered width-59pcnt padding-0p5 height-28">
            <app-base-bar-drilldown-chart
              [chartId]="chart.options[dropdown.selectedValue].barChart.byGroup.chartId"
              [additionalOptions]="chart.options[dropdown.selectedValue].barChart.byGroup.additionalOptions">
            </app-base-bar-drilldown-chart>
          </div>
          <div class="bordered width-39pcnt padding-0p5 height-28">
            <app-base-pie-chart
              [chartId]="chart.options[dropdown.selectedValue].pieChart.byGroup.chartId"
              [additionalOptions]="chart.options[dropdown.selectedValue].pieChart.byGroup.additionalOptions">
            </app-base-pie-chart>
          </div>
        </div>
        <app-data-behind-fv-and-pp-charts
          [selectedOrgName]="organization.name"
          [rawData]="chart.data.fmv.barChart.byGroup.drilldownData"
          [categoryName]="'Group'">
        </app-data-behind-fv-and-pp-charts>
    </div>
    <div *ngIf="selectedTab === tab.ASSETS" class="vertical-container-simple column-gap-1" >
      <div class="centered-row-container row-gap-1">
        <div class="bordered width-59pcnt padding-0p5 height-28">
          <app-base-bar-drilldown-chart
            [chartId]="chart.options[dropdown.selectedValue].barChart.byAssets.chartId"
            [additionalOptions]="chart.options[dropdown.selectedValue].barChart.byAssets.additionalOptions">
          </app-base-bar-drilldown-chart>
        </div>
        <div class="bordered width-39pcnt padding-0p5 height-28">
          <app-base-pie-chart
            [chartId]="chart.options[dropdown.selectedValue].pieChart.byAssets.chartId"
            [additionalOptions]="chart.options[dropdown.selectedValue].pieChart.byAssets.additionalOptions">
          </app-base-pie-chart>
        </div>
      </div>
      <app-data-behind-fv-and-pp-charts
        [selectedOrgName]="organization.name"
        [rawData]="chart.data.fmv.barChart.byAssets.drilldownData"
        [categoryName]="'Assets'">
      </app-data-behind-fv-and-pp-charts>
    </div>
  </div>
</div>

